module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-custom-solutions-367ef6f6b4c9888aeffedb25fff0d8bf.svg";